import{isCustomValue as o}from"../../utils/resolve-value.mjs.js";import{isMotionValue as t}from"./is-motion-value.mjs.js";function e(e){const r=t(e)?e.get():e;return o(r)?r.toValue():r}export{e as resolveMotionValue};
